/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { theme } from "@nordcloud/gnui";
import { DateRange, EstatePeriod, Separator } from "~/components";
import { PeriodSelection } from "../Views";
import { AccumulatedCostData } from "./AccumulatedCostData";
import { Top10CostData } from "./Top10CostData";
import { EstateGroupBy, TotalChartDetails } from "./types";

type Props = {
  period: EstatePeriod;
  range: DateRange | undefined;
  isCostLoading: boolean;
  chartType: EstateGroupBy;
  totalCost?: string;
  count?: number | null;
  monthlySavings?: string | null;
  forecast?: number;
  averageCost?: string;
  extraDetails?: TotalChartDetails;
};

export function EstateTotals({
  period,
  range,
  isCostLoading = false,
  chartType,
  totalCost,
  count,
  monthlySavings,
  forecast,
  averageCost,
  extraDetails,
}: Props) {
  return (
    <>
      <PeriodSelection period={period} range={range} />
      <Separator css={{ marginBottom: theme.spacing.spacing04 }} />
      <When condition={chartType === EstateGroupBy.NONE}>
        <AccumulatedCostData
          totalCost={totalCost}
          count={count}
          monthlySavings={monthlySavings}
          isLoading={isCostLoading}
          forecast={forecast}
          averageCost={averageCost}
          period={period}
        />
      </When>
      <When condition={chartType === EstateGroupBy.APP}>
        <Top10CostData
          count={count}
          isLoading={isCostLoading}
          chartType={chartType}
          totalTop={extraDetails?.totalTop ?? "-"}
          totalOther={extraDetails?.totalOther ?? "-"}
        />
      </When>
    </>
  );
}
